/**
 * SharedProjectTrackItem Component
 */

import { getDefaultTrackAsset, getResponsiveTrackThumbnail, getTrackPriceElement } from '../../../utils/track';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Card from '../../molecules/media/Card';

interface IOwnProps {
  license: ILicenseUsage[];
  size: CardSize;
  track: GQL.ITrackSearchResult;
  version: string;
  title: string;
}

const classes = new BEM('shared-project__track-item');

export const SharedProjectTrackItem: React.SFC<IOwnProps> = (props) => {
  const { license, size, title, track, version } = props;
  const {
    artist,
    assets,
  } = track;

  return (
    <Card
      actionSource="shared_project_list"
      backgroundColor="bw3"
      image={getResponsiveTrackThumbnail(track)}
      options={['PriceElement', 'ShowDetails', 'FindSimilar']}
      PriceElement={getTrackPriceElement(track, {
        buttonProps: {
          variant: 'pill',
          size: size === 'small' ? 'xsmall' : 'small',
          withShadow: true,
        },
        addToCartButtonProps: {
          usages: license,
        },
      })}
      size={size}
      subtitle={artist!.name!}
      title={title!}
      trackId={getDefaultTrackAsset(assets!, version!).id}
      trackResult={track}
      {...classes('card') }
    />
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/SharedProject/SharedProjectTrackItem.tsx